import React, { useMemo } from "react";

import { Route, useSearchParams } from "react-router-dom";

import { PipelinesApiProvider } from "./hooks/api";

const LazyPipelinesListPage = React.lazy(
  () => import("./components/PipelinesList")
);
const LazyPipelineDetailsPage = React.lazy(
  () => import("./components/PipelineDetails")
);
const LazyPipelineCreatePage = React.lazy(
  () => import("./components/PipelineCreate")
);
const LazyPipelineUploadPage = React.lazy(
  () => import("./components/PipelineUpload")
);
const LazyFlinkController = React.lazy(
  () => import("./components/FlinkController")
);

export const routes = (
  <>
    <Route index element={<LazyPipelinesListPage />} />
    <Route path=":pipelineId" element={<LazyPipelineDetailsPage />} />
    <Route path="create" element={<PipelineCreation />} />
  </>
);

export const flinkUiRoute = (
  <Route path=":pipelineId/flink/ui" element={<LazyFlinkController />} />
);

// Pick pipeline creation flow based on type query param (defaults to SQL flow)
function PipelineCreation() {
  const [searchParams] = useSearchParams();

  const type = useMemo(() => searchParams.get("type"), []);

  if (type === "custom") return <LazyPipelineUploadPage />;
  return <LazyPipelineCreatePage />;
}

export { PipelinesApiProvider };
